module.exports = __webpack_public_path__ + "img/reentry-blue@2x.e21326ff.png";